<template>
  <div>
    <div class="client_list_header">
      <div class="header_title" v-text="$t('client.list')" />
    </div>
    <Board>
      <template #header class="mb-6">
        <div class="d-flex justify-space-between align-center">
          <BaseButton
            icon="$mdiPlus"
            @click="$store.commit('client/setDisplayClientDialog', true)"
          >
            {{ $t("client.create") }}
          </BaseButton>
          <div>
            <v-text-field
              v-model="searchClientField"
              class="ma-0 pa-0"
              outlined
              :label="$t('client.search')"
              prepend-inner-icon="$mdiMagnify"
              dense
              hide-details
              @input="onSearch"
            />
          </div>
        </div>
      </template>
      <template #main>
        <base-button class="mr-2" @click.stop="exportContact('all')">
          {{ $t("organization.export_all_contact") }}
        </base-button>
        <base-button v-if="selectedClients.length" @click.stop="exportContact">
          {{
            $t("organization.export_contact", {
              number: selectedClients.length,
            })
          }}
        </base-button>

        <div>
          <BaseDataTable
            :items="clientsFiltered"
            :loading="isFetchingClients"
            :loading-text="$t('utils.loadingData')"
            sort-by="dateCreated"
            sort-desc
            must-sort
            hide-default-footer
          >
            <template #header>
              <thead>
                <tr>
                  <th>
                    <input
                      v-model="isAllSeclected"
                      :checked="isAllChecked()"
                      type="checkbox"
                      @change="checkAll"
                    />
                  </th>
                  <th>{{ $t("utils.fullname") }}</th>
                  <th>{{ $tc("utils.email", 1) }}</th>
                  <th>{{ $tc("client.socialReason", 2) }}</th>
                  <th>{{ $tc("utils.agreement", 2) }}</th>
                </tr>
              </thead>
            </template>
            <template #item="{ item }">
              <tr
                class="row--link"
                @click="
                  $router.push({
                    name: 'clientDetail',
                    params: {
                      organizationId: $route.params.organizationId,
                      clientId: item.id,
                    },
                  })
                "
              >
                <!-- Selected -->
                <td @click.stop>
                  <input
                    :checked="selectedClients.includes(item.id)"
                    type="checkbox"
                    class="check_folder"
                    @change="checkClient(item.id)"
                  />
                </td>
                <!-- Firstname & Lastname -->
                <td>
                  <span
                    class="text"
                    v-text="
                      item.fullName ? item.fullName : $t('answer.noContent')
                    "
                  />
                </td>
                <!-- Email -->
                <td>
                  <span
                    class="text"
                    v-text="item.email ? item.email : $t('answer.noContent')"
                  />
                </td>
                <!-- Social Reason -->
                <td>
                  <span
                    class="text"
                    v-text="
                      item.societyName
                        ? item.societyName
                        : $t('answer.noContent')
                    "
                  />
                </td>
                <!-- Consentment -->
                <td class="text-end">
                  <BaseChip :type="statusType(item)" :color="statusType(item)">
                    <span
                      class="text_sm"
                      v-text="
                        `${item.recordsCompletedCount}/${item.recordsTotalCount}`
                      "
                    />
                  </BaseChip>
                </td>
              </tr>
            </template>
          </BaseDataTable>
          <div v-if="clientsCount > 10" class="pagination">
            <v-pagination
              v-model="filters.page"
              :total-visible="filters.pageSize"
              :length="clientPages"
              @input="changeFilters"
            />
          </div>
        </div>
      </template>
    </Board>
    <BaseDescription
      v-if="clients"
      class="mt-6"
      v-text="`${clientsCount} contact${clientsCount > 1 ? 's' : ''}`"
    />

    <ClientCreateDialog />
  </div>
</template>

<script>
import Board from "@/core/Components/Board";
import ClientCreateDialog from "../Components/ClientCreateDialog.vue";
import { saveAs } from "file-saver";

import { mapState } from "vuex";
import BaseButton from "../../../core/Components/UI/Button/BaseButton.vue";
import Oauth from "@/core/Models/Oauth";

export default {
  name: "ClientList",
  components: {
    Board,
    ClientCreateDialog,
    BaseButton,
  },
  data() {
    return {
      filters: {
        pageSize: 10,
        page: 1,
      },
      isAllSeclected: false,
      selectedClients: [],
      displayClients: null,
      recordAnswer: null,
      searchClientField: "",
      timeOut: null,
      isExporting: false,
    };
  },
  computed: {
    ...mapState({
      clients: (state) => state.client.clients,
      clientsCount: (state) => state.client.clientsCount,
      isFetchingClients: (state) => state.client.isFetchingClients,
    }),
    clientPages() {
      return Math.ceil(this.clientsCount / this.filters.pageSize);
    },
    clientsFiltered() {
      const clients = this.clients.map((client) => ({
        ...client,
        fullName: client.fullName ? client.fullName : "Anonyme",
      }));

      return clients;
    },
    breadcrumbsItems() {
      return [
        {
          text: this.$store.state.organization.activeOrganization.name,
          disabled: false,
          exact: true,
          to: {
            name: "organization",
            params: { organizationId: this.$route.params.organizationId },
          },
        },
        {
          text: this.$tc("organization.client", 10),
          exact: true,
          to: { name: "clientList" },
        },
        {
          text: this.$tc("organization.folder", 10),
          disabled: false,
          to: { name: "folderList" },
        },
      ];
    },
  },
  watch: {
    organizationId: {
      handler() {
        this.reset();
        this.initialize();
      },
      immediate: true,
    },
  },
  destroyed() {
    this.reset();
  },
  methods: {
    async exportContact(state) {
      this.isExporting = true;

      try {
        const oauth = Oauth.localStorage;
        const myHeaders = new Headers({
          Authorization: `Bearer ${oauth.accessToken}`,
          "Content-Type": "application/json",
        });
        const myInit = {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify({ user_ids: [...this.selectedClients] }),
        };
        if (state === "all") delete myInit.body;

        const response = await fetch(
          `/api/web/organization/${this.$route.params.organizationId}/client/export/`,
          myInit
        );
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        saveAs(await response.blob(), "Export_contact.csv");
      } catch {
        this.$store.dispatch("snackbar/active", {
          message: this.$t("utils.errorHasHappen"),
          type: "ERROR",
        });
      }
      this.isExporting = false;
    },

    checkAll(value) {
      this.selectedClients = [];
      if (value.target.checked)
        return (this.selectedClients = this.clientsFiltered.map(
          (client) => client.id
        ));
    },
    checkClient(clientId) {
      const indexClient = this.selectedClients.findIndex(
        (client) => client == clientId
      );
      if (indexClient == -1) return this.selectedClients.push(clientId);
      return this.selectedClients.splice(indexClient, 1);
    },
    isAllChecked() {
      if (!this.clientsFiltered.length) return false;
      if (this.selectedClients.length === this.clientsFiltered.length)
        return (this.isAllSeclected = true);
      return (this.isAllSeclected = false);
    },
    reset() {
      this.$store.commit("client/setClients", []);
      this.$store.commit("client/setClientsCount", 0);
      this.$store.commit("client/setIsFetchingClients", false);
      this.$store.commit("client/setDisplayClientDialog", false);
    },
    initialize() {
      this.$store.dispatch("client/fetchOrganizationClients", {
        organizationId: this.$route.params.organizationId,
        page: this.filters.page,
        pageSize: this.filters.pageSize,
      });
    },
    statusType(item) {
      if (item.recordsCompletedCount == 0) {
        return "primary";
      } else if (item.recordsCompletedCount < item.recordsTotalCount) {
        return "secondary";
      }
      return "tertiary";
    },
    changeFilters() {
      this.$emit("changeValue", this.filters);
      this.$store.dispatch("client/fetchOrganizationClients", {
        organizationId: this.$route.params.organizationId,
        page: this.filters.page,
        pageSize: this.filters.pageSize,
      });
      this.selectedClients = [];
    },

    onSearch(event) {
      if (this.timeOut) clearTimeout(this.timeOut);
      this.timeOut = setTimeout(() => {
        this.filters.page = 1;
        this.$store.dispatch("client/searchClients", {
          organizationId: this.$route.params.organizationId,
          page: this.filters.page,
          pageSize: this.filters.pageSize,
          search: event,
        });
      }, 500);
    },
  },
};
</script>

<style lang="scss" scoped>
.client_list_header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
  .header_title {
    font-weight: 600;
    font-size: 24px;
    line-height: 30px;
    color: #353542;
    margin-top: 8px;
  }
}
td {
  cursor: pointer;
}
.pagination {
  display: flex;
  justify-content: center;
  max-width: 600px;
  margin: auto;
  margin-top: 20px;
}
</style>
